import React from 'react';
import SEO from '../../../common/SEO';
import Layout from '../../../common/Layout';
import BreadcrumbOne from '../../../common/breadcrumb/BreadcrumbOne';
import RegisterProgramForm from '../../../components/form/register-program-form/RegisterProgramForm';
// import { Link } from 'react-router-dom';

const EventData = [
	{
		"id": 1,
		"title": "Wildfire Risk Forecasting",
		"image": "wildfire.webp",
		// "website": "https://ovet.app/",
		// "industry": "Healthcare",
		// "rating": "4.8 Google Rating",
		// "duration": "12 Weeks",
		"category": "Forestry / CleanTech",
		"location": "https://bayesstudio.com/",
		// "going": "140+",
		"company": "Bayes Studio"
	}
]

const WildfireRiskForecasting = ({
	showRegisterForm,
	setShowRegisterForm,
	company
	}) => {
	const eventItem = EventData[0];
	return (
		<>
			<SEO
				title={ eventItem.title }
				description=""
			/>
			<Layout>
				<BreadcrumbOne 
					title={eventItem.title}
					rootUrl="/programs/work-integrated-learning"
					parentUrl="Industry Partner Work Integrated Learning"
					currentUrl={eventItem.title}
				/>
				<div className="edu-event-details-area edu-event-details edu-section-gap bg-color-white">
					<div className="container">
						<div className="row g-5">
							<div className="col-lg-12">
								<div className="thumbnail">
									<img src={`${process.env.PUBLIC_URL}/images/project-details/${ eventItem.image }`} alt="Event Thumb" />
								</div>
							</div>
						</div>
						<div className="row g-5">
							<div className="col-lg-7">
								<div className="content">
									<h3 className="title">{ eventItem.title }</h3>
									<p>
										<strong>What is the main goal for this project?</strong><br></br>
										This project investigates how artificial intelligence can support environmental sustainability and risk preparedness. The goal is to build a data-driven system that uses weather, satellite, and vegetation information to help predict areas at higher risk of environmental hazards, such as wildfires—empowering better planning and emergency response strategies.
									</p>
									<p className="mb-0">
										<strong>What tasks will learners need to complete to achieve the project goal?</strong><br></br>
									</p>
									<ul>
										<li>
											Collect and prepare environmental datasets, including satellite and weather data.
										</li>
										<li>
											Build scripts to analyze geographic patterns and vegetation indicators.
										</li>
										<li>
											Integrate multiple data sources to support predictive modeling workflows.
										</li>
										<li>
											Assist in validating AI models using historical event data.
										</li>
										<li>
											Help develop dashboards that visualize trends and risk levels across regions.
										</li>
									</ul>
									<p className="mb-0">
										These activities introduce learners to geospatial analysis, environmental AI, and predictive modeling.
									</p>
									<p className="mb-0">
										<strong>How will you support learners in completing the project?</strong><br></br>
										Learners will be supported by mentors experienced in geospatial AI and applied machine learning. The project offers structured roadmaps, collaborative tools, and weekly review checkpoints. This ensures that participants gain end-to-end experience in AI model development—from data preparation to actionable insights for environmental resilience.
									</p>
								</div>
							</div>
							<div className="col-lg-5">
								<div className="eduvibe-sidebar">
									<div className="eduvibe-widget eduvibe-widget-details">
										<h5 className="title">ABOUT INDUSTRY PARTNER</h5>
										<div className="widget-content">
											<ul>
												{/* <li><span><i className="icon-Campus"></i> { eventItem.company }</span></li> */}
												<li><span><i className="icon-Campus"></i> <a href={eventItem.location}>{ eventItem.company }</a></span></li>
												<li><span><i className="icon-presentation"></i> { eventItem.category }</span></li>
												{/* <li><span><i className="icon-map-pin-line"></i> {company ? <a href={eventItem.location}>Website</a> : eventItem.location}</span></li> */}
												<li>
													Bayes Studio builds AI-powered solutions for wildfire detection and environmental monitoring. Using multispectral sensors and real-time data analysis, their platform enables early fire detection and rapid response to reduce disaster impact. Designed for governments, utilities, and insurers, Bayes Studio helps improve preparedness, minimize losses, and protect communities from climate-related risks.
												</li>
											</ul>
											{!company && <div className="read-more-btn mt--45">
												<a className="edu-btn btn-secondary text-center" href="https://form.jotform.com/m2mtech/wil-programs-sign-up">Register Now<i className="icon-arrow-right-line-right"></i></a>
											</div>}
										</div>
									</div>
								</div>
							</div>
							{!company && <div className="col-lg-12">
								<div className="read-more-btn text-center">
									<a className="edu-btn btn-secondary text-center" href="https://form.jotform.com/m2mtech/wil-programs-sign-up">Register Now<i className="icon-arrow-right-line-right"></i></a>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</Layout>
			{showRegisterForm && <RegisterProgramForm setShowRegisterForm={setShowRegisterForm} />}
		</>
	)
}
export default WildfireRiskForecasting;